import { createActionTypes } from "lib/utils/createActionTypes";

export default class UIDucks {
  public static initialState = {
    appBarOpen: true,
    navBarOpen: false,
    navBarOpen2: false,
    resultFound: false,
    searchTerm: '',
    result: ['']
  };

  public static duckName = "UI";

  public static actionTypes: any = createActionTypes(
    {
      getIsAppBarOpen: "get_is_app_bar_open".toUpperCase(),
      getIsNavBarOpen: "get_is_nav_bar_open".toUpperCase(),
      getIsNavBarOpen2: "get_is_nav_bar_open_2".toUpperCase(),
      setNavBar: "set_nav_bar".toUpperCase(),
      setAppBar: "set_app_bar".toUpperCase(),
      setNavBar2: "set_nav_bar_2".toUpperCase(),
      search: "search".toLowerCase()
    },
    UIDucks.duckName
  );

  public static setUserEvents = (events: any[]) => dispatch => {
    dispatch({
      type: UIDucks.actionTypes.setUserEvents,
      payload: { events }
    });
  };

  public static getOwnState = state =>
    state[UIDucks.duckName] || UIDucks.initialState;
  public static getIsAppBarOpen(state) {
    return this.getOwnState(state).appBarOpen;
  }
  public static getIsNavBarOpen(state) {
    return this.getOwnState(state).navBarOpen;
  }
  public static getState(state) {
    return state;
  }

  public static getIsNavBarOpen2(state) {
    return this.getOwnState(state).navBarOpen2;
  }
  public static setAppBar = (open: boolean = false) => dispatch => {
    dispatch({
      type: UIDucks.actionTypes.setAppBar,
      payload: { appBarOpen: open }
    });
  };

  public static setNavBar = (open: boolean = false) => dispatch => {
    dispatch({
      type: UIDucks.actionTypes.setNavBar,
      payload: { navBarOpen: open }
    });
  };

  public static setNavBar2 = (open: boolean = false) => dispatch => {
    dispatch({
      type: UIDucks.actionTypes.setNavBar2,
      payload: { navBarOpen2: open }
    });
  };

  public static search = (obj: any) => dispatch => {
    dispatch({
      type: UIDucks.actionTypes.search,
      payload: { ...obj }
    })
  }

  public static reducer(state = UIDucks.initialState, action) {
    switch (action.type) {
      case UIDucks.actionTypes.setAppBar:
        return {
          ...state,
          appBarOpen: action.payload.appBarOpen
        };
      case UIDucks.actionTypes.setNavBar:
        return {
          ...state,
          navBarOpen: action.payload.navBarOpen
        };

      case UIDucks.actionTypes.setNavBar2:
        return {
          ...state,
          navBarOpen2: action.payload.navBarOpen2
        };

      case UIDucks.actionTypes.search:
        return {
          ...state,
          ...action.payload
        };
      default:
        return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/ducks/UI.duck.ts